export enum EProjectDiscussionFileAction {
  COMMENT = 'C',
  RESPONSE = 'R',
}

export enum EProjectDiscussionFileType {
  TRANSMITTAL = 'Transmittal',
  LAMBETH_REVIEWER_RESPONSE = 'LRR',
  DESIGN_BRIEF = 'T2',
  DESIGN_MODIFICATION_DESIGNER = 'T3D',
  DESIGN_MODIFICATION_ICE = 'T3I',
  DESIGN_MODIFICATION_REVIEWER = 'T3R',
  LOADING_REMOVAL_CERT = 'T4C',
  LIR = 'LIR',
  P5_DESIGNER = 'P5D',
  P5_PDM = 'P5PDM',
  P6_SITE = 'P6SITE',
  P6_DESIGNER = 'P6DESIGNER',
}
